import React from "react"
import ContractorTimeslotItem from "./contractor_timeslot_item"
import {stars} from "../../util/rating_util"
import {withRouter} from "react-router-dom"
import UserAvatar from "../photographers/photograher_avatar"
import LogoSpinner from "../../../../assets/images/landing/video-thumbnails/MA-logo-spinner-transparent.gif";
import {formatDatetime, formatTime} from "../../util/date_util";
import { railsToJsTimezoneMap } from "../../util/timezone_utils";
import BookingCalendar from "./booking_calendar";
import debounce from 'debounce'
import { debouncePromise } from "../../util/custom_function_utils"
import PhotographerReviews from "../photographers/photographers_reviews"
import {fetchPhotographerWithReviews} from "../../util/service_api_util";
import Modal from "react-modal";

class ContractorCalendar extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      selected: new Date(),
      selectedTime: "",
      dates: [],
      month: new Date(),
      currentDay: new Date(),
      confirmModal: false,
      isLargeScreen: typeof window === 'undefined' ? true : window.innerWidth > 750,
      loading: false,
      reviewsModalOpen: false,
      detailedPhotographer: null,
      reviewsLoading: false,
    }
    this.handler = this.handler.bind(this)
    this.applyTime = this.applyTime.bind(this)
    this.addMonth = this.addMonth.bind(this)
    this.subtractMonth = this.subtractMonth.bind(this)
    this.addDays = this.addDays.bind(this)
    this.subtractDays = this.subtractDays.bind(this)
    this.handleTimeSelect = this.handleTimeSelect.bind(this)
    this.toggleReviewsModal = this.toggleReviewsModal.bind(this);
    this.fetchDetailedPhotographer = this.fetchDetailedPhotographer.bind(this);
    this.updatePredicate = this.updatePredicate.bind(this)
    this.debouceScrollTo = debounce((selector) => this.scrollTo(selector), 200)

    // debouncePromise only cancels a call while it's still waiting out the
    // debounce delay — once it's actually fired (a real fetchTimes request
    // in flight), a later date change can't cancel it, and if that older
    // request's response happens to arrive after the newer one, it would
    // still clear `loading` and let the (now-stale) time slots be clicked.
    // fetchRequestId makes each call's resolution conditional on still being
    // the most recent one, so a late/out-of-order response for an
    // already-superseded date is simply ignored instead of hiding the
    // loading spinner over stale times.
    this.fetchRequestId = 0
    const debouncedFetchTimes = debouncePromise((options) => {
      return this.props.fetchTimes(options);
    }, 500);
    this.debounceFetchTimes = (options) => {
      const requestId = ++this.fetchRequestId
      return new Promise((resolve) => {
        debouncedFetchTimes(options).then(() => {
          if (requestId === this.fetchRequestId) resolve()
        })
      })
    }
    this.modalContentRef = React.createRef()
  }

  componentDidMount() {
    document.body.style.overflow = 'hidden';
    this.updatePredicate();
    window.addEventListener("resize", this.updatePredicate);

    let today_date = new Date()
    today_date.setDate(today_date.getDate() + 1)

    let previous_time_set = false
    let previousAppointmentTime = ""

    if (this.props.appointments[this.props.selectedService]?.contractor && this.props.appointments[this.props.selectedService]?.appointment_time) {
      previousAppointmentTime = this.props.appointments[this.props.selectedService]?.appointment_time
      today_date = new Date(previousAppointmentTime)
      today_date.setHours(0, 0, 0, 0)
      previous_time_set = true
    }

    let dates = this.getDaysInMonth(today_date)
    let firstSelectable = previous_time_set ? today_date : this.getFirstSelectableDate(dates)
    this.setState({
      dates: dates,
      currentDay: firstSelectable,
      selected: firstSelectable,
      selectedTime: previous_time_set ? previousAppointmentTime : "",
      month: today_date,
      loading: true
    })

    this.debounceFetchTimes({
      date: firstSelectable,
      contractor_id: this.props.photographer.id,
      service_id: this.props.selectedService,
      street: this.props.street,
      timezone: this.props.detected_timezone || this.props.project?.client?.timezone || this.props.client_timezone,
      long_shoot: this.props.long_shoot 
    }).then(() => this.setState({ loading: false }))
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.updatePredicate);
    document.body.style.overflow = 'unset';
  }

  toggleReviewsModal() {
    if (!this.state.reviewsModalOpen) {
      // Open modal and fetch detailed photographer
      this.fetchDetailedPhotographer();
    } else {
      // Close modal
      this.setState({ reviewsModalOpen: false });
    }
  }

  async fetchDetailedPhotographer() {
    this.setState({ reviewsLoading: true, reviewsModalOpen: true });
    try {
      const detailedPhotographer = await fetchPhotographerWithReviews(this.props.photographer.id);
      this.setState({ detailedPhotographer, reviewsLoading: false });
    } catch (error) {
      console.error("Failed to fetch detailed photographer:", error);
      this.setState({ reviewsLoading: false });
    }
  }

  scrollTo(selector) {
    const element = document.querySelector(selector)
    if (element) element.scrollIntoView()
  }

  updatePredicate() {
    this.setState({isLargeScreen: window.innerWidth > 550});
  }

  addDays() {
    let currentDay = new Date(this.state.currentDay)

    if (this.state.isLargeScreen){
      currentDay.setDate(currentDay.getDate() + 10)
    } else {
      currentDay.setDate(currentDay.getDate() + 5)
    }

    if (currentDay.getMonth() !== this.state.currentDay.getMonth()) {
      currentDay.setDate(1)
    }

    let dates = this.getDaysInMonth(currentDay)
    let firstSelectable = this.getFirstSelectableDate(dates)
    this.setState({ dates: dates, currentDay: firstSelectable, month: currentDay, selected: firstSelectable, selectedTime: "", loading: true})

    this.debounceFetchTimes({
      date: firstSelectable,
      contractor_id: this.props.photographer.id,
      service_id: this.props.selectedService,
      street: this.props.street,
      timezone: this.props.detected_timezone || this.props.project?.client?.timezone || this.props.client_timezone,
      long_shoot: this.props.long_shoot
    }).then(() => this.setState({ loading: false }))
  }

  subtractDays() {
    let currentDay = new Date(this.state.currentDay)

    if (this.state.isLargeScreen) {
      if (currentDay.getDate() < 11 && currentDay.getDate() != 1){
        currentDay.setDate(1)
      } else{
        currentDay.setDate(currentDay.getDate() - 10)
      }
    } else {
      if (currentDay.getDate() < 6 && currentDay.getDate() != 1) {
        currentDay.setDate(1)
      } else {
      currentDay.setDate(currentDay.getDate() - 5)
      }
    }

    let todayDate = new Date()

    todayDate.setDate(todayDate.getDate() + 1)

    if (currentDay < todayDate && !this.props.currentUser?.roles?.admin) {
      let dates = this.getDaysInMonth(todayDate)
      let firstSelectable = this.getFirstSelectableDate(dates)
      this.setState({ dates: dates, currentDay: firstSelectable, month: todayDate, selected: firstSelectable, selectedTime: "", loading: true })
      this.debounceFetchTimes({
        date: firstSelectable,
        contractor_id: this.props.photographer.id,
        service_id: this.props.selectedService,
        street: this.props.street,
        timezone: this.props.detected_timezone || this.props.client_timezone || this.props.project?.client?.timezone || this.props.currentUser?.timezone,
        long_shoot: this.props.long_shoot
      }).then(() => this.setState({ loading: false }))
    } else {
      let dates = this.getDaysInMonth(currentDay)
      let firstSelectable = this.getFirstSelectableDate(dates)
      this.setState({ dates: dates, currentDay: firstSelectable, month: currentDay, selected: firstSelectable, selectedTime: "", loading: true })
      this.debounceFetchTimes({
        date: firstSelectable,
        contractor_id: this.props.photographer.id,
        service_id: this.props.selectedService,
        street: this.props.street,
        timezone: this.props.detected_timezone || this.props.client_timezone || this.props.project?.client?.timezone || this.props.currentUser?.timezone,
        long_shoot: this.props.long_shoot
      }).then(() => this.setState({ loading: false }))
    }
  }

  applyTime() {
    if (this.state.selectedTime !== "") {
      if (this.props.updating && !this.state.confirmModal){
        this.setState({confirmModal: true})
        this.debouceScrollTo(".sub-modal-background")
      } else{
      this.props.setAppointmentTime(this.state.selectedTime, this.props.photographer)
      this.props.changeSelected(null, null, true)
      this.props.handleNext && this.props.handleNext()
      }
    }
  }

  addMonth() {
    let date = new Date(this.state.month.getFullYear(), this.state.month.getMonth() + 1, 1)

    let dates = this.getDaysInMonth(date)
    let firstSelectable = this.getFirstSelectableDate(dates)

    this.setState({ dates: dates, month: date, currentDay: firstSelectable, selected: firstSelectable, selectedTime: "", loading: true })

    this.debounceFetchTimes({
      date: firstSelectable,
      contractor_id: this.props.photographer.id,
      service_id: this.props.selectedService,
      street: this.props.street,
      timezone: this.props.detected_timezone || this.props.project?.client?.timezone || this.props.client_timezone
    }).then(() => this.setState({ loading: false }))
  }

  subtractMonth() {
    let today_date = new Date()
    let date = new Date(this.state.month.getFullYear(), this.state.month.getMonth(), 1)

    if (date.getMonth() != today_date.getMonth() || this.props.currentUser?.roles?.admin) {
      date = new Date(this.state.month.getFullYear(), this.state.month.getMonth() - 1, 1)
    }

    let dates = this.getDaysInMonth(date)
    let firstSelectable = this.getFirstSelectableDate(dates)

    this.setState({ dates: dates, month: date, currentDay: firstSelectable, selected: firstSelectable, selectedTime: "", loading: true })

    this.debounceFetchTimes({
      date: firstSelectable,
      contractor_id: this.props.photographer.id,
      service_id: this.props.selectedService,
      street: this.props.street,
      timezone: this.props.detected_timezone || this.props.project?.client?.timezone || this.props.client_timezone
    }).then(() => this.setState({ loading: false }))
  }

  getDaysInMonth(date) {
    let month = date.getMonth()
    let year = date.getFullYear()
    let new_date = new Date(year, month, 1)

    let days = []
    while (new_date.getMonth() === month) {
      days.push(new Date(new_date))
      new_date.setDate(new_date.getDate() + 1)
    }
    return days
  }

  getFirstSelectableDate(dates) {
    const today = new Date()
    today.setHours(0, 0, 0, 0)
    return dates.find(d => {
      const normalized = new Date(d)
      normalized.setHours(0, 0, 0, 0)
      return normalized > today
    }) || dates[dates.length - 1]
  }

  changeSelected(index) {
    this.setState({ selected: this.state.dates[index], selectedTime: "", loading: true })
    this.debounceFetchTimes({
      date: this.state.dates[index],
      contractor_id: this.props.photographer.id,
      service_id: this.props.selectedService,
      street: this.props.street,
      timezone: this.props.detected_timezone || this.props.client_timezone || this.props.project?.client?.timezone || this.props.currentUser?.timezone,
      long_shoot: this.props.long_shoot
    }).then(() => this.setState({loading: false}))
  }

  handler(newState) {
    this.setState(newState)
  }

  handleTimeSelect(time) {
    if (this.state.selectedTime.toString() === time.toString()) {
      this.setState({selectedTime: ""})
    } else {
      this.setState({selectedTime: time})
    }
  }


  render() {

    const { reviewsLoading, detailedPhotographer, reviewsModalOpen } = this.state;

    const today = new Date()
    today.setHours(0, 0, 0, 0)
    const isAdmin = this.props.currentUser?.roles?.admin

    const isCurrentMonth = this.state.month.getMonth() === today.getMonth() &&
                           this.state.month.getFullYear() === today.getFullYear()

    const mostRecentSunday = new Date(today)
    mostRecentSunday.setDate(today.getDate() - today.getDay())
    mostRecentSunday.setHours(0, 0, 0, 0)

    const firstDate = this.state.dates[0]
    // Same rule as before: in the current month, customers don't see weeks
    // that are already over.
    const hidePastWeeks = isCurrentMonth && !isAdmin && firstDate && mostRecentSunday >= firstDate

    const visible = []
    this.state.dates.forEach((date, index) => {
      const normalized = new Date(date)
      normalized.setHours(0, 0, 0, 0)
      if (hidePastWeeks && normalized < mostRecentSunday) return
      visible.push({ date, index, normalized })
    })

    const days = []
    if (visible.length > 0) {
      for (let i = 0; i < visible[0].date.getDay(); i++) days.push({ key: `blank-${i}`, blank: true })
    }
    visible.forEach(({ date, index, normalized }) => {
      const isPast = normalized <= today
      const isSelected = this.state.selected?.toString() === date.toString()
      const clickable = !isPast || isAdmin
      days.push({
        key: `d-${index}`,
        num: date.getDate(),
        selected: isSelected && clickable,
        disabled: !clickable,
        ariaLabel: date.toLocaleString('en-US', { weekday: 'long', month: 'long', day: 'numeric' }),
        onClick: clickable ? () => this.changeSelected(index) : undefined
      })
    })

    let selectedTime = this.state.selectedTime

    let time_slots = this.props.times.map(time => {
      return {time: new Date(time.start_time), unavailable: time.unavailable}
    })

    let times = time_slots.map((time_slot, i) =>
      <ContractorTimeslotItem key={i} time={time_slot.time} unavailable={time_slot.unavailable} selected={selectedTime.toString() === time_slot.time.toString()} project={this.props.project}
                              currentUser={this.props.currentUser} detected_timezone={this.props.detected_timezone} client_timezone={this.props.client_timezone} handleTimeSelect={this.handleTimeSelect} changeParentState={this.handler}/>
    )

    let photographer = this.props.photographer

    let modal = ""

    if (this.state.confirmModal){
      modal = <div className="modal-background sub-modal-background" style={{ zIndex: 10002 }} onClick={() => this.setState({confirmModal: false})}>
        <div className="orderpreviewModal" onClick={e => e.stopPropagation()}>
          <div className="orderPreviewModalComponent">
            <div className="contractorModalHeading">
              <div className="confirmationModalDescription">Are you sure you want to make this change?</div>
            </div>
            <div className="confirmationTimeSlotsButtons">
              <div onClick={() => this.setState({ confirmModal: false })} className="signupFormPrevious">Cancel</div>
              <div onClick={this.applyTime} className="signupFormNext" id={this.state.selectedTime === "" ? 'disabled' : ''}>Apply</div>
            </div>
          </div>
        </div>
      </div>
    }

    const timezone = this.props.detected_timezone || this.props.client_timezone || this.props.project?.client?.timezone || this.props.currentUser?.timezone
    const dayLabel = this.state.selected ? formatDatetime(this.state.selected, "dddd, MMMM D", timezone) : ''
    const shortDay = this.state.selected ? formatDatetime(this.state.selected, "ddd, MMM D", timezone) : ''
    const timeLabel = selectedTime !== "" ? formatTime(new Date(selectedTime), railsToJsTimezoneMap[timezone]) : ''
    const photographerName = [photographer.firstName || photographer.first_name, (photographer.lastName || photographer.last_name || '')[0]].filter(Boolean).join(' ')

    return <BookingCalendar
      title="Select a date and time"
      subtitle={photographerName ? `Open dates and times for ${photographerName}.` : "Open dates and times for the selected photographer."}
      onClose={() => this.props.changeSelected(null)}
      monthLabel={this.state.month.toLocaleString('en-US', { month: 'long', year: 'numeric' })}
      onPrevMonth={this.subtractMonth}
      onNextMonth={this.addMonth}
      prevDisabled={isCurrentMonth && !isAdmin}
      days={days}
      timesHeading={dayLabel}
      timezoneNote={timezone ? `Times are shown in ${timezone}` : null}
      times={times}
      timesLoading={this.state.loading}
      emptyTimesText="No times for this date"
      summary={shortDay ? `${shortDay} · ${timeLabel || 'pick a time'}` : 'Choose a date and time'}
      applyLabel="Apply"
      onApply={this.applyTime}
      applyDisabled={this.state.selectedTime === ""}
    >
      {modal}
      <Modal
        isOpen={reviewsModalOpen}
        onRequestClose={this.toggleReviewsModal}
        ariaHideApp={false}
        className="photographerReviewModal"
        overlayClassName="reviewModalOverlay"
      >
        {reviewsLoading ? (
          <div onClick={(e) => e.stopPropagation()}>
            <div className="createProjectLogoSpinner">
              <img className="logoImageSpinnerGif" src={LogoSpinner}></img>
            </div>
          </div>
        ) : detailedPhotographer ? (
          <div onClick={(e) => e.stopPropagation()}>
              <PhotographerReviews reviewModal={true} changeSelected={this.toggleReviewsModal} toggleReviewsModal={this.toggleReviewsModal} currentUser={this.props.currentUser} photographer={detailedPhotographer} />
          </div>
        ) : (
          <p>No reviews available.</p>
        )}
      </Modal>
    </BookingCalendar>
  }
}

export default withRouter(ContractorCalendar)